// Reference trap card value: A=1 … 10, J=11, Q=12, K=13; a back ("1") counts 0
export function trapCardValue(c) {
  if (c == null || String(c) === "1") return 0;
  const s = String(c);
  let r = s.length === 4 ? s.slice(0, 2) : s.slice(0, 1);
  if (r === "K") r = 13;
  if (r === "Q") r = 12;
  if (r === "J") r = 11;
  if (r === "A") r = 1;
  return parseInt(r, 10) || 0;
}

// Player A = even-index cards, Player B = odd-index cards
export function trapCounts(cards) {
  let a = 0;
  let b = 0;
  cards.forEach((c, i) => {
    if (i % 2 === 0) a += trapCardValue(c);
    else b += trapCardValue(c);
  });
  return { a, b };
}
